import { call, put, takeLatest } from "redux-saga/effects";
import { OP } from "../../constant";
import {
  doActivateMerchant,
  doAddMerchant,
  doCreateMerchantAccount,
  doUpdateMerchantAccount,
  doDeactivateMerchant,
  doFetchMerchant,
  doFetchMerchantTransactions,
  doViewMerchant,
  doViewMerchantTransaction,
  doFetchMerchantProperties,
  doCreateMerchantProperty,
  doUpdateMerchantProperty,
  doDeleteMerchantProperty,
} from "../../service/merchant";

import errorMessage from "../../utils/error.json";

// fetch merchant list
function* fetchMerchantTask(action) {
  try {
    yield put({ type: OP.MERCHANT_LIST_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(doFetchMerchant, payload.token);

    if (res.status == 200) {
      yield put({
        type: OP.MERCHANT_LIST_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.MERCHANT_LIST_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.MERCHANT_LIST_FAILURE,
      payload: errMsg,
    });
  }
}

// add merchant
function* addMerchantTask(action) {
  try {
    yield put({ type: OP.ADD_MERCHANT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doAddMerchant,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.ADD_MERCHANT_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.ADD_MERCHANT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.ADD_MERCHANT_FAILURE,
      payload: errMsg,
    });
  }
}

// create merchant account
function* createMerchantAccountTask(action) {
  try {
    yield put({ type: OP.CREATE_MERCHANT_ACCOUNT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doCreateMerchantAccount,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.CREATE_MERCHANT_ACCOUNT_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.CREATE_MERCHANT_ACCOUNT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.CREATE_MERCHANT_ACCOUNT_FAILURE,
      payload: errMsg,
    });
  }
}

// update merchant account
function* updateMerchantAccountTask(action) {
  try {
    yield put({ type: OP.UPDATE_MERCHANT_ACCOUNT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doUpdateMerchantAccount,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.UPDATE_MERCHANT_ACCOUNT_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.UPDATE_MERCHANT_ACCOUNT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.UPDATE_MERCHANT_ACCOUNT_FAILURE,
      payload: errMsg,
    });
  }
}

// view merchant
function* viewMerchantTask(action) {
  try {
    yield put({ type: OP.VIEW_MERCHANT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doViewMerchant,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.VIEW_MERCHANT_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.VIEW_MERCHANT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.VIEW_MERCHANT_FAILURE,
      payload: errMsg,
    });
  }
}

// activate merchant
function* activateMerchantTask(action) {
  try {
    yield put({ type: OP.ACTIVATE_MERCHANT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doActivateMerchant,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.ACTIVATE_MERCHANT_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.ACTIVATE_MERCHANT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.ACTIVATE_MERCHANT_FAILURE,
      payload: errMsg,
    });
  }
}

// deactivate merchant
function* deactivateMerchantTask(action) {
  try {
    yield put({ type: OP.DEACTIVATE_MERCHANT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doDeactivateMerchant,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.DEACTIVATE_MERCHANT_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.DEACTIVATE_MERCHANT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.DEACTIVATE_MERCHANT_FAILURE,
      payload: errMsg,
    });
  }
}

// merchant transactions list
function* merchantTransactionsTask(action) {
  try {
    yield put({ type: OP.MERCHANT_TRANSACTIONS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doFetchMerchantTransactions,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.MERCHANT_TRANSACTIONS_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.MERCHANT_TRANSACTIONS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({ type: OP.MERCHANT_TRANSACTIONS_FAILURE, payload: errMsg });
  }
}

// view one merchant transaction
function* viewMerchantTransactionTask(action) {
  try {
    yield put({ type: OP.VIEW_MERCHANT_TRANSACTION_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doViewMerchantTransaction,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.VIEW_MERCHANT_TRANSACTION_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.VIEW_MERCHANT_TRANSACTION_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.VIEW_MERCHANT_TRANSACTION_FAILURE,
      payload: errMsg,
    });
  }
}

// merchant properties list
function* merchantPropertiesTask(action) {
  try {
    yield put({ type: OP.MERCHANT_PROPERTIES_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doFetchMerchantProperties,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.MERCHANT_PROPERTIES_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.MERCHANT_PROPERTIES_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.MERCHANT_PROPERTIES_FAILURE,
      payload: errMsg,
    });
  }
}

// create merchant property
function* createMerchantPropertyTask(action) {
  try {
    yield put({ type: OP.CREATE_MERCHANT_PROPERTY_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doCreateMerchantProperty,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.CREATE_MERCHANT_PROPERTY_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.CREATE_MERCHANT_PROPERTY_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.CREATE_MERCHANT_PROPERTY_FAILURE,
      payload: errMsg,
    });
  }
}

// update merchant property
function* updateMerchantPropertyTask(action) {
  try {
    yield put({ type: OP.UPDATE_MERCHANT_PROPERTY_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doUpdateMerchantProperty,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.UPDATE_MERCHANT_PROPERTY_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.UPDATE_MERCHANT_PROPERTY_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[1000];
    yield put({
      type: OP.UPDATE_MERCHANT_PROPERTY_FAILURE,
      payload: errMsg,
    });
  }
}

// delete merchant property
function* deleteMerchantPropertyTask(action) {
  try {
    yield put({ type: OP.DELETE_MERCHANT_PROPERTY_LOADING });

    const { payload } = action;

    const { res } = yield call(
      doDeleteMerchantProperty,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.DELETE_MERCHANT_PROPERTY_SUCCESS,
        payload: payload.data?.id,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.DELETE_MERCHANT_PROPERTY_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.DELETE_MERCHANT_PROPERTY_FAILURE,
      payload: errMsg,
    });
  }
}

function* merchantSaga() {
  yield takeLatest(OP.MERCHANT_LIST_REQUEST, fetchMerchantTask);
  yield takeLatest(OP.ADD_MERCHANT_REQUEST, addMerchantTask);
  yield takeLatest(
    OP.CREATE_MERCHANT_ACCOUNT_REQUEST,
    createMerchantAccountTask,
  );
  yield takeLatest(
    OP.UPDATE_MERCHANT_ACCOUNT_REQUEST,
    updateMerchantAccountTask,
  );
  yield takeLatest(OP.VIEW_MERCHANT_REQUEST, viewMerchantTask);
  yield takeLatest(OP.ACTIVATE_MERCHANT_REQUEST, activateMerchantTask);
  yield takeLatest(OP.DEACTIVATE_MERCHANT_REQUEST, deactivateMerchantTask);
  yield takeLatest(OP.MERCHANT_TRANSACTIONS_REQUEST, merchantTransactionsTask);
  yield takeLatest(
    OP.VIEW_MERCHANT_TRANSACTION_REQUEST,
    viewMerchantTransactionTask,
  );
  yield takeLatest(OP.MERCHANT_PROPERTIES_REQUEST, merchantPropertiesTask);
  yield takeLatest(OP.CREATE_MERCHANT_PROPERTY_REQUEST, createMerchantPropertyTask);
  yield takeLatest(OP.UPDATE_MERCHANT_PROPERTY_REQUEST, updateMerchantPropertyTask);
  yield takeLatest(OP.DELETE_MERCHANT_PROPERTY_REQUEST, deleteMerchantPropertyTask);
}

export default merchantSaga;
